import React from "react";
import { Box, Tooltip, Chip } from "@mui/material";
import { Lock } from "@mui/icons-material";

// TODO: this is ready for future checks on frontend when I add that ticket but not currently used - will need tweaking

export const hasFeature = (obj, feature) => {
  if (!obj?.tieredFeatures) return false;
  return obj.tieredFeatures.includes(feature);
};

const TieredFeatureAccess = ({
  obj,
  feature,
  children,
  fallback = null,
  blur = true,
  disabled = true,
  accessOverride = null,
  menuItem = false,
  inlineButton = false,
  tooltipMessage = "Upgrade to unlock this feature",
}) => {
  const allowed = accessOverride ?? hasFeature(obj, feature);
  if (allowed) {
    return children;
  }

  if (fallback) {
    return fallback;
  }
  if (!allowed && menuItem) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        {/* Dimmed content */}
        <Box sx={{ opacity: 0.5, display: "flex", alignItems: "center" }}>
          {children}
        </Box>

        {/* Clean chip */}
        <Chip
          label="Upgrade"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ ml: 1 }}
          clickable
        />
      </Box>
    );
  }

  if (inlineButton) {
    // For inline buttons (IconButton, Button), use position relative without stretching
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <Box
          sx={{
            pointerEvents: disabled ? "none" : "auto",
            opacity: 0.6,
            filter: blur ? "blur(1px)" : "none",
          }}
        >
          {children}
        </Box>

        {/* Overlay with lock icon */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Tooltip title={tooltipMessage} arrow>
            <Lock
              sx={{
                fontSize: 24,
                color: "primary.main",
                cursor: "help",
                backgroundColor: "rgba(255,255,255,0.8)",
                borderRadius: "50%",
                padding: 0.5,
              }}
            />
          </Tooltip>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative", width: "100%", display: "block" }}>
      <Box
        sx={{
          pointerEvents: disabled ? "none" : "auto",
          opacity: 0.6,
          filter: blur ? "blur(1px)" : "none",
        }}
      >
        {children}
      </Box>

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 1, // optional
        }}
      >
        <Tooltip title={tooltipMessage} arrow>
          <Lock sx={{ fontSize: 40, color: "primary.main", cursor: "help" }} />
        </Tooltip>
      </Box>
    </Box>
  );
};

export default TieredFeatureAccess;
